import React, { useState } from 'react';
import '../styles/Footer.css';

// TODO: Add real routes to all these Hrefs

function Footer() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left Column */}
        <div className="footer-column">
          <a href="/faqs">FAQS</a>
          <a href="/purchase-note">PURCHASE NOTE</a>
          <a href="/privacy">PRIVACY</a>
        </div>

        {/* Right Column */}
        <div className="footer-column">
          <a href="/about" style={{ textAlign: 'center' }}>ABOUT</a>
          <a href="/contact" style={{ textAlign: 'center' }}>CONTACT US</a>
        </div>

        <div className="footer-right">
          <a
            href="https://www.instagram.com/codysanderson_official/?igshid=3x580c3e0y9a"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="index/instagram.png" alt="Instagram" />
          </a>
          <a
            href="https://www.xiaohongshu.com/user/profile/5fb6a975000000000101f6de?xhsshare=CopyLink&appuid=5fb6a975000000000101f6de&apptime=1615391370"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="index/SmallRedBook.png" alt="Small Red Book" />
          </a>
          <a
            href="https://codysanderson.com/ContactUs"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="index/line.png" alt="Line" />
          </a>
          <button
            onClick={() => alert('WeChat QR code or action goes here')}
            className="icon-button"
            aria-label="WeChat"
          >
            <img src="index/wechat.png" alt="Wechat" />
          </button>
        </div>
      </div>

      <div className="footer-center">
        <button id="locationButton" onClick={toggleDropdown}>
          LOCATION ▼
        </button>
        <div
          id="locationDropdown"
          className="location-dropdown"
          style={{ display: isDropdownOpen ? 'block' : 'none' }}
        >
          <div><a href="/locations/taipei">TAIWAN, TAIPEI ▶</a></div>
          <div><a href="/locations/tokyo">JAPAN, TOKYO ▶</a></div>
          <div><a href="/locations/la">USA, LOS ANGELES ▶</a></div>
        </div>
      </div>

      <div className="footer-bottom">
        CODY SANDERSON INC. ©2025
      </div>
    </footer>
  );
}

export default Footer;